import React from "react";
import Style from "./Home.module.scss";
import EmojiBullet from "./EmojiBullet";
import { Box } from "@mui/material";
import { info } from "../../info/Info";

const Intro = () => {
  return (
    <Box
      component={"main"}
      display={"flex"}
      flexDirection={{ xs: "column", md: "row" }}
      alignItems={"center"}
      justifyContent={"center"}
      minHeight={"100vh"}
    >
      <Box>
        <h1>
          Hi, I'm{" "}
          <span
            style={{
              background: info.gradient,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {info.firstName}
          </span>
          <span className={Style.hand}>🤚</span>
        </h1>
        <h2>{info.position}.</h2>
        <Box component={"ul"} p={"0.8rem"}>
          {info.miniBio.map((bio, index) => (
            <EmojiBullet key={index} emoji={bio.emoji} text={bio.text} />
          ))}
        </Box>
        <Box component={"ul"} p={"0.8rem"}>
          <span
            style={{
              background: info.gradient,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: 20,
              cursor: "pointer",
              borderBottom: `3px solid transparent`,
            }}
            onClick={() => {
              window.open("https://medium.com/@bibhuti9");
            }}
          >
            Read My Blogs
          </span>
        </Box>
      </Box>
    </Box>
  );
};

export default function Home() {
  return (
    <Box
      component={"main"}
      display={"flex"}
      flexDirection="column" // Set to column to stack components vertically
      alignItems={"center"}
      justifyContent={"center"}
      minHeight={"100vh"}
    >
      <Intro />
    </Box>
  );
}
